import {Route} from "../../registry/routes.js"
import Explorer from "../../components/core/Explorer.vue"
import filebrowse from "./filebrowse.js"
import binsdisplay from "./binsdisplay.js"
import catalogdisplay from "./catalogsdisplay.js"
import dashboard from "./dashboard.js"
import favourites from "./favourites.js"
// import review from "./review.js"
import share from "./share.js"
// import metadataManager from "./metadataManagerAssetDetails.js"
import jobs from "./jobs.js"
import reports from "./reports.js"
import settings from "./settings.js"
import userPref from "./userPreference.js"
import upload from "./upload.js"
// import chat from "./chat/chat.js"
// import remoteStat from "./remoteStats.js"
// import subclipManager from "./subclipManager.js"
//import ticket from "./tickets.js"
// import hype from "./hype.js"
//import pam from "./pam.js"
//import taskWindow from "./tasksWindow"
// import MediaEdit from "./assetModal/partialRetrieve.js"
// import AssetMediaEdit from "./SubPartialRetrieve.js"
// import subclipsManager from "../../components/subclips/Subclips.vue";
// import PartialRetrieve from '../../components/partialRetrieve/PartialRetrieve.vue'
// import EditPro from "./editPro.js"
//import mediaPipeline from "./mediaPipeline.js"
//import mediaPipelineWorkspace from "./mediaPipelineWorkspace.js"
//import importCSV from "./importCSVFile.js"
import favouritesAdmin from "./favouriteAdmin.js";
//import mediaQC from "./mediaQC.js";
import Terms from "../../components/sessions/Terms.vue"
import Policy from "../../components/sessions/Policy.vue"
// const MediaEditFromSubclipFromMetadataDock = new Route("subclip-asset-PartialRetrieve", "mediaedit/:subclipId?", {"PartialRetrieve":PartialRetrieve}, {componentType:"asset_modal_component",title:"Media Edit"}, [], true, (to, from, next)=>{document.title=`${document.title}`;next();})
// const MetadataDockSubclip = new Route("metadata-sub-clips-manager", "subclip/:subclipId?", {"metadata-sub-clips-manager":subclipsManager}, {componentType:"tag_modal_component", title: "Subclips"}, [MediaEditFromSubclipFromMetadataDock], true, null)

/***
 *  removed  mediaPipeline , mediaPipelineWorkspace , importCSV, metadataManager , mediaQC , EditPro
 */
const termsroute = new Route("terms_of_service", "terms_of_service" , {"terms_of_service":Terms}, {componentType:"terms_component", title:"Terms"}, [], true, null)
const policyroute = new Route("privacy_policy", "privacy_policy" , {"privacy_policy":Policy}, {componentType:"policy_component", title:"Policy"}, [], true, null)


let children = [dashboard, favourites, binsdisplay, catalogdisplay.route, filebrowse, upload,
                  jobs, reports, settings, userPref, share , favouritesAdmin,termsroute, policyroute]

const r = new Route("explorer", "/explorer", {explorer:Explorer}, {componentType:"explorer_component", title:"Explorer"}, children, true, null)

export default r;